/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { Button } from '@mui/material';
import React from 'react';
import { LanguageContext } from '../../../libs/Context';
import PropTypes from 'prop-types';
class ErrorBoundary extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state = {
			hasError : false,
			error    : null,
			info     : null
		};
	}

	componentDidCatch(error, info)
	{
		this.setState({
			hasError : true,
			error,
			info
		});
	}

	handleRefresh()
	{
		window.location.href = '/news';
	}

	render()
	{
		if (this.state.hasError)
		{
			return (
				<LanguageContext.Consumer>
					{(value) =>
					{
						const { langLocalContextVal } = value;

						return (
							<div className='flexCol alignCntr justifyCntr pdngSM fullVirtualHeight'>
								<div className='categoryImgBlock'>
									<img src='/images/network-error.png' alt='nopage'/>
								</div>
								<div className='flexCol alignCntr mrgnTSM'>
									<span className='subHeadingSM textCntr  mrgnBMD'>Network error, something went wrong</span>
									<Button
										disableElevation
										disableFocusRipple
										disableRipple
										disableTouchRipple
										color='primary'
										onClick={this.handleRefresh}
										variant='contained'
										className='whiteTxt'
										size='large'
									>
										Go to home
									</Button>
								</div>
							</div>
						);
					}}
				</LanguageContext.Consumer>
			);
		}

		return this.props.children;
	}
}

ErrorBoundary.propTypes = {
	children : PropTypes.any
};

export default ErrorBoundary;